import { WorkspacePreferences } from "@/lib/graphql/types-and-hooks";
import { isLovablePreview } from "@/lib/utils/environment";

// Preference keys that represent app state (not feature flags) and must
// NOT be forced on/off by Preview Mode.
const PREVIEW_STATE_KEYS = new Set<string>(["trial_expired"]);

export const isPreferenceEnabled = (
  key: string,
  pref: WorkspacePreferences | null | undefined
) => {
  if (isLovablePreview() && !PREVIEW_STATE_KEYS.has(key)) {
    return true;
  }
  try {
    const obj = JSON.parse(pref?.preferences ?? "{}");
    if (Object.prototype.hasOwnProperty.call(obj, key) && !!obj[key]) {
      return true;
    }
    return false;
  } catch (e) {
    console.error(e);
  }
};

export const isPreferenceDisabled = (
  key: string,
  pref: WorkspacePreferences | null | undefined
) => {
  if (isLovablePreview() && !PREVIEW_STATE_KEYS.has(key)) {
    return false;
  }
  try {
    const obj = JSON.parse(pref?.preferences ?? "{}");
    if (Object.prototype.hasOwnProperty.call(obj, key) && !obj[key]) {
      return true;
    }
    return false;
  } catch (e) {
    console.error(e);
  }
};
